/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarePrincipalExportFinalSettingsEntity
 */
export interface CarePrincipalExportFinalSettingsEntity {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportFinalSettingsEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportFinalSettingsEntity
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportFinalSettingsEntity
     */
    cardType?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportFinalSettingsEntity
     */
    cronPattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalExportFinalSettingsEntity
     */
    excludeMissingPatients?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportFinalSettingsEntity
     */
    ftpName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalExportFinalSettingsEntity
     */
    emptyExportFiles?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CarePrincipalExportFinalSettingsEntity
     */
    validDays?: number;
}

export function CarePrincipalExportFinalSettingsEntityFromJSON(json: any): CarePrincipalExportFinalSettingsEntity {
    return CarePrincipalExportFinalSettingsEntityFromJSONTyped(json, false);
}

export function CarePrincipalExportFinalSettingsEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalExportFinalSettingsEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'cardType': !exists(json, 'cardType') ? undefined : json['cardType'],
        'cronPattern': !exists(json, 'cronPattern') ? undefined : json['cronPattern'],
        'excludeMissingPatients': !exists(json, 'excludeMissingPatients') ? undefined : json['excludeMissingPatients'],
        'ftpName': !exists(json, 'ftpName') ? undefined : json['ftpName'],
        'emptyExportFiles': !exists(json, 'emptyExportFiles') ? undefined : json['emptyExportFiles'],
        'validDays': !exists(json, 'validDays') ? undefined : json['validDays'],
    };
}

export function CarePrincipalExportFinalSettingsEntityToJSON(value?: CarePrincipalExportFinalSettingsEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'carePrincipalId': value.carePrincipalId,
        'cardType': value.cardType,
        'cronPattern': value.cronPattern,
        'excludeMissingPatients': value.excludeMissingPatients,
        'ftpName': value.ftpName,
        'emptyExportFiles': value.emptyExportFiles,
        'validDays': value.validDays,
    };
}

